<div class="match-parent">
  <div class="map match-parent" id="map"></div>
  <div class="map-style" *ngIf="showStyleToggle">
    <input type="checkbox" id="isSatellite" class="map-checkbox" [(ngModel)]="isSatellite" /> &nbsp;
    <label for="isSatellite">Satellite View</label>
    <div *ngIf="showFlagScoreContainer" class="flag-score-container">
      <span>Flag auto-score</span>
      <div class="checkbox-item" style="margin-top: 15px">
        <input
          type="checkbox"
          class="ch-box"
          id="score0"
          [(ngModel)]="score0"
          (ngModelChange)="scoreChanged()"
          checked />
        <label for="score0" style="margin-bottom: 0 !important">
          <span class="dot" style="color: green"><i class="fa fa-map-marker"></i></span>
        </label>
        <span>0</span>
      </div>
      <div class="checkbox-item">
        <input
          type="checkbox"
          class="ch-box"
          id="score1-3"
          [(ngModel)]="score1"
          (ngModelChange)="scoreChanged()"
          checked />
        <label for="score1-3" style="margin-bottom: 0 !important">
          <span class="dot" style="color: yellow"><i class="fa fa-map-marker"></i></span> 1-3
        </label>
      </div>
      <div class="checkbox-item">
        <input
          type="checkbox"
          class="ch-box"
          id="score5-10"
          [(ngModel)]="score2"
          (ngModelChange)="scoreChanged()"
          checked />
        <label for="score5-10" style="margin-bottom: 0 !important">
          <span class="dot" style="color: orange"><i class="fa fa-map-marker"></i></span> 5-10
        </label>
      </div>
      <div class="checkbox-item">
        <input
          type="checkbox"
          class="ch-box"
          id="score100"
          [(ngModel)]="score3"
          (ngModelChange)="scoreChanged()"
          checked />
        <label for="score100" style="margin-bottom: 0 !important">
          <span class="dot" style="color: red"><i class="fa fa-map-marker"></i></span> 100
        </label>
      </div>
    </div>
  </div>
  <div id="hidden-geocoder"></div>
</div>
